<template>
  <div class="activate-page">
    <div class="loading-message" v-if="isLoaded">Verifying Account...</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoaded: false
    };
  },
  mounted() {
    if (!this.$route.query.code) {
      this.$router.push("/");
      return;
    }

    this.isLoaded = true;

    const secretCode = this.$route.query.code;
    this.$repo.user
      .activate(secretCode)
      .then(() => {
        this.isLoaded = false;
        this.$router.push("/dashboard");
      })
      .catch(error => {
        window.location.href = "/";
      });
  }
};
</script>

<style lang="scss" scoped>
.activate-page {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  color: #fff;
  z-index: 1001;
  font-size: 36px;

  .loading-message {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
  }
}
</style>